export const SHIFT_TYPE_ID = {
	CLASSROOM: 1,
	ESSAY_REVIEW: 2,
};
